import { node } from 'prop-types';
import { Component } from 'react';

import StyledText from './StyledText';

const defaultPlaceholder = (
  <StyledText size="32px" margin="100px 0 100px 54px" isBold>
    Něco se tu pokazilo :(
  </StyledText>
);

class ErrorBoundary extends Component {
  state = { error: null, info: null };

  componentDidCatch(error, info) {
    this.setState({
      error: error,
      info: info,
    });
  }

  render() {
    const { error } = this.state;
    const { placeholder, children } = this.props;

    const preferedPlaceHolder = placeholder || defaultPlaceholder;

    return error ? preferedPlaceHolder : children;
  }
}

ErrorBoundary.propTypes = {
  children: node,
  placeholder: node,
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// components/shared/ErrorBoundary.js